import React from "react";
import G2 from "@antv/g2";
import { equals } from "ramda";
import moment from "moment";
import { Row, Col, Icon } from "antd";
import styled from "styled-components";
import i18n from "../../../i18n";
import GraphConst from "../../../constants/graph";
import { CallChannelKeys, Sessions } from "../../../util/appointments";
import {
	calVisitTitle,
	mutateDateByViewBy,
	createObjectTimeOf
} from "../../../util/graph";
import store from "../../../reducers";
import { DevelopmentArea } from "../../../util/dev_layout";
import { ArrayUtil } from "../../../util";
import DatePagination from "../../bar/DatePagination";

const DATE = GraphConst.DATE;
const VIEW_MODE = {
	VISIT: "visit",
	DURATION: "duration",
	USER: "user"
};
class CounselingSessionsGraph extends React.Component {
	state = {
		title: "",
		viewMode: VIEW_MODE.VISIT,
		viewBy: DATE.YEAR,
		viewValue: {
			[VIEW_MODE.VISIT]: 0,
			[VIEW_MODE.DURATION]: 0,
			[VIEW_MODE.USER]: 0
		},
		viewChartData: [],
		move: 0
	};
	acceptAppointment = [];
	constructor(props) {
		super(props);
		const { appointments } = props;
		this.initChartValue(appointments);
	}
	componentWillReceiveProps(nextProps) {
		const { appointments } = nextProps;
		this.setState(this.initChartValue(appointments), this.updateChart);
	}

	componentDidMount() {
		const { appointments } = this.props;
		this.setState(this.initChartValue(appointments), this.updateChart);
		this.initChart();
		this.chart.render();
	}

	initChart = () => {
		const { viewChartData } = this.state;
		if (!this.chart) {
			this.chart = new G2.Chart({
				container: "chart",
				forceFit: true,
				height: 380
			});
			this.chart.source(viewChartData);
			this.chart.on("plotclick", ev =>
				this.onClickChart(this.chart.getTooltipItems({ x: ev.x, y: ev.y })[0])
			);
			this.chart.tooltip({
				crosshairs: { type: "line" }
			});
			this.chart.legend(false);
			this.chart.area().position("title*value"); //.color('section');
			this.chart
				.line()
				.position("title*value")
				.size(2); //.color('section').size(2);
		}
		// this.filterSessions()
		this.calRenderChart();
		window.dispatchEvent(new Event("resize"));
	};
	initChartValue(appointments) {
		const { viewBy, viewMode } = this.state;
		this.acceptAppointment = appointments.filter(
			a =>
				a.call_channel === CallChannelKeys.WEB &&
				a.status === Sessions.COMPLETED
		);
		return {
			viewValue: this.countViewValue(this.acceptAppointment),
			viewChartData: this.createViewChartData(
				this.acceptAppointment,
				viewBy,
				viewMode
			)
		};
	}
	updateChart = () => {
		const { viewChartData } = this.state;
		this.chart.source(viewChartData);
		this.chart.render();
	};
	countViewValue(acceptAppointment) {
		const viewValue = {
			[VIEW_MODE.VISIT]: 0,
			[VIEW_MODE.DURATION]: 0,
			[VIEW_MODE.USER]: 0,
			[VIEW_MODE.SESSION]: 0
		};
		const uniqueUserID = [];
		let totalDuration = 0;
		let totalSession = 0;
		acceptAppointment.forEach(a => {
			const { reserved_duration, extension_duration } = a;
			totalDuration += reserved_duration;
			totalSession += reserved_duration / 30;
			if (extension_duration) totalSession += extension_duration / 30;
			const {
				patient_profile: {
					data: { user_id }
				}
			} = a;
			if (uniqueUserID.indexOf(user_id) === -1) {
				uniqueUserID.push(user_id);
			}
		});
		viewValue[VIEW_MODE.VISIT] = acceptAppointment.length;
		viewValue[VIEW_MODE.DURATION] = totalDuration;
		viewValue[VIEW_MODE.USER] = uniqueUserID.length;
		viewValue[VIEW_MODE.SESSION] = totalSession;
		return viewValue;
	}
	createViewChartData(
		acceptAPPs,
		viewBy = DATE.MONTH,
		viewMode = VIEW_MODE.VISIT,
		selected = null
	) {
		const { move } = this.state;
		const sumObject = createObjectTimeOf({
			selected,
			viewBy,
			move,
			keyMod: date => mutateDateByViewBy({ date: date.format("X"), viewBy })
		});
		const uniqueUserID = {};
		if (viewMode === VIEW_MODE.USER) {
			Object.keys(sumObject).forEach(e => {
				uniqueUserID[e] = [];
			});
		}
		acceptAPPs.forEach(a => {
			const { created } = a;
			const dateKey = mutateDateByViewBy({ date: created, viewBy });
			if (sumObject[dateKey] !== undefined) {
				let value = 0;
				switch (viewMode) {
				case VIEW_MODE.VISIT:
					value = 1;
					break;
				case VIEW_MODE.DURATION:
					value = a.reserved_duration;
					break;
				case VIEW_MODE.USER:
					const {
						patient_profile: {
							data: { user_id }
						}
					} = a;
					if (uniqueUserID[dateKey].indexOf(user_id) === -1) {
						uniqueUserID[dateKey].push(user_id);
						value = 1;
					}
					break;
				}
				sumObject[dateKey].value = (sumObject[dateKey].value || 0) + value;
			}
		});
		const out = Object.keys(sumObject).map(key => {
			return {
				title: key,
				value: sumObject[key].value,
				date: sumObject[key].date
			};
		});
		// console.log('createViewChartData.out: ',out);
		return out;
	}
	onToggleSessionView = inputViewMode => {
		const { viewMode, viewBy } = this.state;
		if (inputViewMode !== viewMode) {
			this.setState(
				{
					viewMode: inputViewMode,
					viewChartData: this.createViewChartData(
						this.acceptAppointment,
						viewBy,
						inputViewMode
					)
				},
				this.updateChart
			);
		}
	};

	changeViewBy = viewBy => {
		const { viewMode } = this.state;
		this.setState(
			{
				viewBy,
				viewChartData: this.createViewChartData(
					this.acceptAppointment,
					viewBy,
					viewMode
				)
			},
			() => this.calRenderChart()
		);
	};
	/**
	 * Go deeper into chart data.
	 */
	onClickChart = data => {
		const { viewBy, move } = this.state;
		switch (viewBy) {
		case DATE.YEAR:
			this.calRenderChart(data, move, DATE.MONTH);
			break;
		case DATE.MONTH:
			this.calRenderChart(data, move, DATE.WEEK);
			break;
		case DATE.WEEK:
			this.calRenderChart(data, move, DATE.DAY);
			break;
		default:
			break;
		}
	};
	/**
	 * Recalculate chart source
	 * @param {object} data
	 * @param {number} move
	 * @param {DATE} nextViewBy
	 */
	calRenderChart(data, move, nextViewBy) {
		const { appointments } = this.props;
		const { viewBy, viewMode } = this.state;

		if (!move && this.state.move != 0) {
			this.setState({ move: 0 });
		}
		const viewChartData = this.createViewChartData(
			this.acceptAppointment,
			nextViewBy || viewBy,
			viewMode,
			data ? data.title : null
		);
		this.setState(
			{
				viewBy: nextViewBy || viewBy,
				title: calVisitTitle(viewChartData),
				viewChartData
			},
			this.updateChart
		);
	}
	// Move date by one section of time.
	onClickMoveGraph(value) {
		const { move } = this.state;
		this.setState({ move: move + value }, () => {
			this.calRenderChart(null, this.state.move);
		});
	}

	render() {
		const {
			organization: {
				organization: { color }
			}
		} = store.getState();
		const { viewMode, viewBy, title, viewValue } = this.state;
		return (
			<div>
				<div>
					<Row gutter={16}>
						<ColSession>
							<SessionButton
								onClick={() => this.onToggleSessionView(VIEW_MODE.VISIT)}
								title={i18n.t("counseling_visit")}
								description={viewValue[VIEW_MODE.VISIT]}
								active={viewMode === VIEW_MODE.VISIT}
								subDescription={viewValue[VIEW_MODE.SESSION]}
							/>
						</ColSession>
						{/* <ColSession>
							<SessionButton
								onClick={() => this.onToggleSessionView(VIEW_MODE.VISIT)}
								title={i18n.t("counseling_session")}
								description={viewValue[VIEW_MODE.SESSION]}
								active={viewMode === VIEW_MODE.VISIT}
							/>
						</ColSession> */}
						<ColSession>
							<SessionButton
								onClick={() => this.onToggleSessionView(VIEW_MODE.DURATION)}
								title={i18n.t("duration")}
								description={`${viewValue[VIEW_MODE.DURATION]} mins`}
								active={viewMode === VIEW_MODE.DURATION}
							/>
						</ColSession>
						<ColSession>
							<SessionButton
								onClick={() => this.onToggleSessionView(VIEW_MODE.USER)}
								title={i18n.t("user")}
								description={viewValue[VIEW_MODE.USER]}
								active={viewMode === VIEW_MODE.USER}
							/>
						</ColSession>
					</Row>
				</div>
				<div style={{ border: "1px solid #e8e8e8", borderRadius: 4 }}>
					<Row style={{ padding: "30px 35px 20px 35px" }}>
						<Col span={12}>
							<div style={{ fontSize: 18 }}>{i18n.t(viewMode)}</div>
							<DatePagination
								color={color}
								onClick={direction => this.onClickMoveGraph(direction)}
								text={title}
							/>
						</Col>
						<Col span={12}>
							<div style={{ float: "right" }}>
								{Object.values(DATE).map((v, i) => (
									<DateButton
										key={i}
										onClick={() => this.changeViewBy(v)}
										active={viewBy == v}
									>
										{v}
									</DateButton>
								))}
							</div>
						</Col>
					</Row>
					<div id="chart" />
				</div>
			</div>
		);
	}
}

export default CounselingSessionsGraph;

const ColSession = styled(Col).attrs({ xs: 24, sm: 24, lg: 5, xl: 3, xxl: 3 })`
	min-width: 190px;
`;

const SessionButtonContainer = styled.div`
	border: ${props => `2px solid ${props.active ? "#00c4b3" : "#e8e8e8"}`};
	border-radius: 4px;
	padding: 5px 15px 5px 15px;
	cursor: pointer;
	margin: 15px 0;
`;

const DateButton = styled.span`
	margin: 0 10px;
	padding: 5px 8px;
	border-radius: 4px;
	cursor: pointer;
	color: #4a4a4a;
	background-color: ${props => (props.active ? "#b3ede8" : "transparent")};
`;
const SessionButton = ({
	title,
	description,
	active,
	onClick,
	subDescription
}) => (
	<SessionButtonContainer active={active} onClick={onClick}>
		<Row>
			<span style={{ color: "#6a7088", fontSize: 14 }}>{title}</span>
		</Row>
		<Row type="flex" justify="space-between" align="bottom">
			<Col span={subDescription ? "12" : "24"} value={100}>
				<span style={{ color: "#161616", fontSize: 24 }}>{description}</span>
			</Col>
			{subDescription ? (
				<Col span={12} value={100}>
					<span style={{ color: "red", fontSize: 12 }}>
						{subDescription} Sessions
					</span>
				</Col>
			) : (
				""
			)}
		</Row>
	</SessionButtonContainer>
);



// WEBPACK FOOTER //
// ./src/components/report/counseling/CounselingSessionGraph.js